<template>
    <div class="two-factor-protection">
        <BaseIconTitle
            :title="tokens.newDesign.twoFactor"
            :material-icon="'qr_code_2_add'"
        />
        <div class="qr-desc">
            <h5 class="body__medium">
                {{ user.otp ? tokens.newDesign.googleTwoFactorIsActive : tokens.newDesign.activateCodeForGoogle }}
            </h5>
            <p class="body__small desc">
                {{ user.otp ? tokens.newDesign.ifYouWishDisableEnterCode : tokens.newDesign.scanOrManuallyEnter }}
            </p>
            <div v-if="!user.otp" class="qr-panel">
                <div class="qr">
                    <QrcodeVue :value="otpEnableData.otpauth_url" :size="100"/>
                </div>
                <div class="qr-info">
                    <h6 class="label__medium">{{tokens.newDesign.qrCode}}</h6>
                    <p class="code body__extrasmall">{{ otpEnableData.base32 }}</p>
                    <BaseButtonSmall
                        class="copy"
                        :button-text="tokens.newDesign.copyCode"
                        :button-style="'tonal-secondary'"
                        @click.native="copy(otpEnableData.base32)"
                    />
                </div>
            </div>
        </div>
        <div class="activate-desc">
            <h5 v-if="!user.otp" class="body__medium">{{tokens.newDesign.activateAndEnterAuthenticator}}</h5>
            <BaseInput
                v-model="codeCheck"
                :info="tokens.newDesign.enterTheDigitsCodeGenerated"
                :type="'password'"
            />
        </div>
        <div class="activate">
            <BaseButton
                :button-text="user.otp ? tokens.newDesign.disableTwoFactor : tokens.newDesign.activateTwoFactor"
                :button-style="'filled-primary'"
                @click.native="makeAction"
            />
        </div>
    </div>
</template>

<script>
import BaseIconTitle from "@/new-design/shared/ui/titles/BaseIconTitle.vue"
import BaseButtonSmall from "@/new-design/shared/ui/buttons/BaseButtonSmall.vue"
import {QR_BRAND_TITLE, QR_TITLE} from "@/common/config"
import QrcodeVue from "qrcode.vue"
import {mapGetters} from "vuex"
import {OTP_ACTIVATE, OTP_DISABLE} from "@/store/actions.type"
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput.vue"
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue"

export default {
    name: "TwoFactorProtection",
    components: {BaseButton, BaseInput, QrcodeVue, BaseButtonSmall, BaseIconTitle},
    data() {
        return {
            qrTitle: QR_TITLE,
            qrTitleBrand: QR_BRAND_TITLE,
            code: '',
            codeCheck: '',
        }
    },
    computed: {
        ...mapGetters(['otpEnableData', 'user','tokens'])
    },
    methods: {
        copy(data) {
            navigator.clipboard.writeText(data)
        },
        makeAction() {
            if (this.user.otp) {
                this.disableOtp()
            } else {
                this.activateOtp()
            }
        },
        activateOtp() {
            this.$store.dispatch(OTP_ACTIVATE, {
                code: this.codeCheck
            })

            this.codeCheck = ''
        },
        disableOtp() {
            this.$store.dispatch(OTP_DISABLE, {
                code: this.codeCheck
            })

            this.codeCheck = ''
        },
    },
    watch: {
        otpEnableData(val) {
            if (this.qrTitle) {
                val.otpauth_url = val.otpauth_url.replace(this.qrTitleBrand, this.qrTitle)
            }
            this.code = val.base32
        }
    }
}
</script>

<style scoped>
.icon-title {
    padding-bottom: 16px;
}

h5 {
    color: var(--System-OnSurface);
}

.desc {
    color: var(--System-OnSurfaceVariant);
}

.activate-desc {
    padding: 16px 0;
}

.qr-desc {
    padding-top: 16px;
}

.qr-panel {
    padding: 16px;
    margin-top: 16px;
    background-color: var(--System-Surface1);
    border-radius: var(--Corner-Extra-small);
    display: flex;
    gap: 16px;
}

.qr {
    padding: 10px;
    border-radius: 2px;
    background: var(--white);
}

.qr-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.copy {
    flex: 0 1;
    width: fit-content;
}

.code {
    word-break: break-all;
}

h6 {
    color: var(--System-OnSurfaceVariant);
}

.activate {
    padding: 16px 0 0;
    width: 100%;
    text-align: right;
}
</style>
